import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface InsertRoleMenusFromRefRequest {
  resourceRoleId: number;
  targetRoleId: number;
  resourceIds: string;
}

export type InsertRoleMenusFromRefResponse = {
  isSuccess: boolean;
  message: string;
  data: any;
};

async function insertRoleMenusFromRef(
  data: InsertRoleMenusFromRefRequest
): Promise<InsertRoleMenusFromRefResponse> {
  try {
    return (await axiosInstance.post("/RoleMenu/InsertRoleMenusFromRef", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useInsertRoleMenusFromRef() {
  return useMutation<InsertRoleMenusFromRefResponse, Error, InsertRoleMenusFromRefRequest>(
    (variables) => insertRoleMenusFromRef(variables)
  );
}
